export default {
	// pt-BR.js
	security: {
		securityBind: "Vinculação de Segurança",
		securitySettings: "Configurações de Segurança",
		level: "Médio",
		confirm: "Confirmar",
		submitting: "Enviando...",
		add: "Adicionar",
		change: "Alterar",
		success: "Atualizado com sucesso",
		select: "Selecionar",

		birthday: "Aniversário de Contato",
		birthdayDesc: "Vincule uma data de nascimento de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		month: "Mês",
		day: "Dia",
		year: "Ano",
		birthdayRequired: "A data de nascimento é obrigatória.",
		invalidBirthday: "Data de nascimento inválida.",
		invalidMonth: "Mês inválido.",
		invalidDay: "Dia inválido.",
		invalidYear: "Ano inválido.",
		updateBirthdayFail: "Falha ao atualizar a data de nascimento",
		birthdayVerify: "Verificação de vínculo de aniversário",
		birthdayVerifyDesc: "Vincule sua data de nascimento para melhorar a segurança da sua conta.",

		email: "E-mail de Contato",
		emailDesc: "E-mail para segurança da conta. Somente você pode vinculá-lo.",
		emailRequired: "O e-mail é obrigatório.",
		emailInvalid: "Endereço de e-mail incorreto.",
		updateEmailFail: "Falha ao atualizar o e-mail",
		emailVerify: "Verificação de vínculo de e-mail",
		emailVerifyDesc: "Verifique seu endereço de e-mail para melhorar a segurança da sua conta.",

		phone: "Número de Telefone",
		bindPhone: "Vincular Número de Telefone",
		phoneDesc: "Número de telefone para segurança da conta. Somente você pode vinculá-lo.",
		phoneRequired: "O número de telefone é obrigatório.",
		phoneUsed: "Use um número de telefone diferente.",
		updatePhoneFail: "Falha ao atualizar o número de telefone",
		noCode: "Não recebeu o código?",
		smsHelp: "Se você tentou várias vezes e ainda não recebeu o código de verificação.",
		smsTips1: "1. Verifique se o número de celular informado está correto.",
		smsTips2: "2. Verifique se o seu número de celular está desatualizado.",
		smsTips3: "3. Verifique se a mensagem está na caixa de SMS.",
		smsTips4: "4. A mensagem pode atrasar alguns minutos.",
		phoneVerify: "Verificação de vínculo de número de telefone",
		phoneVerifyDesc: "Verifique seu número de telefone para melhorar a segurança da sua conta.",

		setPassword: "Definir Senha",
		passwordDesc: "Defina sua senha de login.",
		clickSelectBirthday: "Clique para selecionar o aniversário",
		selectBirthday: "Selecionar Aniversário",
		confirm: "Confirmar",
		cancel: "Cancelar",
		withdrawPassword: "Senha de Saque",
		withdrawpasswordDesc: "Defina sua senha de saque para transações.",
		set: "Definir",
	},
	contactPhone: {
		title: "Alterar Número de Telefone",
		titleMobile: "Alterar",
		description: "Adicione um número de telefone de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		label: "Número de Telefone de Contato",
		confirm: "Confirmar",
		submitting: "Enviando...",
		required: "Número de telefone é obrigatório",
		invalid: "Número de telefone inválido",
		success: "Número de telefone atualizado com sucesso!",
		updateFailed: "Falha na atualização",
		tryAgain: "Falha na atualização, tente novamente mais tarde",
		verifyTitleMobile: "Verificação de Telefone",
		titleMobile: "Vincular Telefone",
		changeTitleMobile: "Alterar Telefone",
		securityTip: "Telefone para segurança da conta. Apenas você pode vinculá-lo.",
		placeholder: "Número de Telefone",
		noCodeReceived: "Não recebeu o código?",
		codeDescription: "Insira o código de verificação de 6 dígitos enviado para os seus dados de contato abaixo:",
		resendIn: "Reenviar em {countdown} s",
		resend: "Reenviar",
		submitting: "Enviando...",
		confirm: "Confirmar",
		invalidCode: "Por favor, insira um código válido de 6 dígitos",
		required: "O número de telefone é obrigatório",
		invalid: "Por favor, insira um número de telefone válido",
		success: "Atualizado com sucesso",
		updateFailed: "Falha na atualização",
		tryAgain: "Por favor, tente novamente mais tarde"
	},

	contactEmail: {
		title: "Alterar Email",
		titleMobile: "Alterar",
		description: "Adicione um email de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		label: "Email de Contato",
		placeholder: "Email",
		confirm: "Confirmar",
		submitting: "Enviando...",
		required: "O email não pode estar vazio",
		invalid: "Por favor, insira um endereço de email válido",
		success: "Email atualizado com sucesso!",
		updateFailed: "Falha na atualização",
		tryAgain: "Falha na atualização, tente novamente mais tarde",
		verifyTitleMobile: "Verificação de E-mail",
		titleMobile: "Vincular E-mail",
		changeTitleMobile: "Alterar E-mail",
		securityTip: "E-mail para segurança da conta. Apenas você pode vinculá-lo.",
		noCodeReceived: "Não recebeu o código?",
		codeDescription: "Insira o código de verificação de 6 dígitos enviado para os seus dados de contato abaixo:",
		resendIn: "Reenviar em {countdown} s",
		resend: "Reenviar",
		submitting: "Enviando...",
		confirm: "Confirmar",
		invalidCode: "Por favor, insira un código válido de 6 dígitos",
		required: "O e-mail é obrigatório",
		invalid: "Por favor, insira um endereço de e-mail válido",
		success: "Atualizado com sucesso",
		updateFailed: "Falha na atualização",
		tryAgain: "Por favor, tente novamente mais tarde"
	},

	accountInfo: {
		profileInfo: "Informações do Perfil",
		contactInfo: "Informações de Contato",
		privacy: "Privacidade",
		contactEmail: "Email de Contato",
		contactPhone: "Número de Telefone de Contato",
		addEmailDesc: "Adicione um email de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		addPhoneDesc: "Adicione um número de telefone de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		hideUsername: "Ocultar meu nome de usuário das listas públicas",
		add: "Adicionar",
		change: "Alterar",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "JOGADOR",
		copied: "Copiado!",
		hideSuccess: "Nome de usuário ocultado com sucesso",
		showSuccess: "Nome de usuário exibido com sucesso",
		operationFailed: "Operação falhou",
		editProfile: "Editar Perfil",
		contactInfo: "Informações de Contato",
		contactEmail: "E-mail de Contato",
		emailTip: "Adicione um e-mail de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		change: "Alterar",
		addEmail: "Adicionar E-mail",
		contactPhone: "Número de Telefone de Contato",
		phoneTip: "Adicione seu número de telefone para verificação segura da conta.",
		addPhone: "Adicionar Número de Telefone",
		birthdayBind: "Verificação de vínculo de aniversário",
		birthdayTip: "Vincule seu aniversário para melhorar a segurança da sua conta.",
		addBirthday: "Adicionar Aniversário",
		personalInfo: "Informações Pessoais",
		personalTip: "Verifique sua identidade para desbloquear mais serviços. Seus dados estão seguros.",
		verifyNow: "Verificar Agora",
		hideUsernameTip: "Quando ativado, outros usuários não poderão ver seu nome de usuário em listas públicas.",
	},

	kyc: {
		title: "Verificação de Identidade",
		verifyIdentity: "Verifique sua identidade",
		completeDesc: "Conclua a verificação de identidade para manter sua conta segura e liberar todos os recursos.",
		failed: "Falha na verificação. Tente novamente.",
		reVerify: "Verificar novamente",
		checkYouOut: "Vamos verificar sua identidade",
		prepareDoc: "Prepare seu documento",
		prepareDocDesc: "Tenha um documento de identidade válido em mãos.",
		useSmartphone: "Use um smartphone",
		useSmartphoneDesc: "Você precisará de um smartphone para concluir a verificação.",
		scanQr: "Escaneie o código QR",
		scanQrDesc: "Escaneie o código QR com seu celular para continuar no celular.",
		noSmartphone: "Não tem smartphone?",
		completeOnMobile: "Concluir no celular"
	},

	verify: {
		title: "Verificação",
		personalVerification: "Verificação Pessoal",
		weak: "Fraco",
		level1: "Nível 1",
		personalInfo: "Informações Pessoais",
		personalInfoDesc: "Complete suas informações pessoais para melhorar a segurança da sua conta.",
		verifyNow: "Verificar Agora",
		level2: "Nível 2",
		kycVerification: "Verificação KYC",
		kycDesc: "Conclua a verificação KYC para liberar limites maiores e acesso total.",
		docTip: "Certifique-se de que seus documentos estejam claros e válidos antes de enviar."
	},

	personalInfo: {
		verify: "Verificação",
		completeInfo: "Complete suas informações",
		completeInfoDesc: "Preencha seus dados pessoais para concluir a verificação.",
		firstName: "Nome",
		paternalSurname: "Sobrenome Paterno",
		maternalSurname: "Sobrenome Materno",
		contactNumber: "Número de Contato",
		phoneUsed: "Este número de telefone já está em uso.",
		contactEmail: "E-mail de Contato",
		invalidEmail: "Endereço de e-mail inválido.",
		detailedAddress: "Endereço Detalhado",
		city: "Cidade",
		street: "Rua",
		neighborhood: "Bairro",
		houseNumber: "Número da Casa",
		postalCode: "Código Postal",
		save: "Salvar",
		male: "Masculino",
		female: "Feminino"
	},

	withdrawPassword: {
		changeTitle: "Alterar Senha de Saque",
		setTitle: "Definir Senha de Saque",
		changeDesc: "Digite sua senha antiga e defina uma nova senha de saque.",
		setDesc: "Defina uma senha de saque para proteger seus fundos.",
		oldPlaceholder: "Senha de Saque Antiga",
		newPlaceholder: "Nova Senha de Saque",
		confirmPlaceholder: "Confirmar Senha de Saque"
	},

	contactBirthday: {
		title: "Aniversário de Contato",
		desc: "Vincule uma data de nascimento de contato para facilitar a comunicação. Suas informações pessoais permanecerão protegidas.",
		label: "Aniversário de Contato",
		invalid: "Data de nascimento inválida."
	},

	changePassword: {
		title: "Alterar Senha",
		expiredDesc: "Sua senha expirou. Defina uma nova senha para continuar.",
		verifyOldDesc: "Digite sua senha antiga e defina uma nova.",
		passwordPlaceholder: "Senha Antiga",
		newPlaceholder: "Nova Senha",
		confirmPlaceholder: "Confirmar Nova Senha",
		lengthError: "A senha deve ter de 6 a 30 caracteres.",
		sameAsOld: "A nova senha não pode ser igual à antiga.",
		confirmRequired: "Confirme sua nova senha.",
		notMatch: "As senhas não coincidem.",
		success: "Senha alterada com sucesso",
		failed: "Falha ao alterar a senha"
	},

	settingsNav: {
		title: "Configurações",
		accountInfo: "Informações da Conta",
		security: "Segurança"
	},

	verificationBirthday: {
		title: "Aniversário",
		securityTip: "Data de nascimento para segurança da conta. Apenas você pode vinculá-la.",
		clickSelectBirthday: "Clique para selecionar o aniversário",
		invalidBirthday: "Data de aniversário inválida",
		submitting: "Enviando...",
		confirm: "Confirmar",
		cancel: "Cancelar",
		selectBirthday: "Selecionar Aniversário",
		birthdayRequired: "A data de nascimento é obrigatória",
		updateBirthdayFail: "Falha ao atualizar o aniversário",
		success: "Atualizado com sucesso"
	}
};